import vsComponent from './vsCheckBox'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
